/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CopyByIdDto } from '../models/CopyByIdDto';
import type { CountResponse } from '../models/CountResponse';
import type { CreateGameCategorySettingsDto } from '../models/CreateGameCategorySettingsDto';
import type { CreateManyGameCategorySettingsEntityDto } from '../models/CreateManyGameCategorySettingsEntityDto';
import type { GameCategorySettingsEntity } from '../models/GameCategorySettingsEntity';
import type { GetManyGameCategorySettingsEntityResponseDto } from '../models/GetManyGameCategorySettingsEntityResponseDto';
import type { UpdateGameCategorySettingsDto } from '../models/UpdateGameCategorySettingsDto';
import type { UpdateManyPositionDto } from '../models/UpdateManyPositionDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import {GetGameCategorySettingsDto} from "@/api/request/games/get-game-category-settings.dto";
import { ListResponseDto } from '@/api/response/list-response.dto';
import { CategorySettingsItemDto } from '@/api/response/categories/category-settings-item.dto';
import { UpdateCategorySettingsItemDto } from '@/api/request/categories/update-category-settings-item.dto';
export class GameCategorySettingsApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns CountResponse
   * @throws ApiError
   */
  public copyGameCategorySettings({
    presetId,
    requestBody,
  }: {
    presetId: number,
    requestBody: CopyByIdDto,
  }): CancelablePromise<CountResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/game-category-settings/preset/{presetId}/copy',
      path: {
        'presetId': presetId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns CountResponse
   * @throws ApiError
   */
  public updateManyPosition({
    requestBody,
  }: {
    requestBody: UpdateManyPositionDto,
  }): CancelablePromise<CountResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/game-category-settings/update-many-position',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Retrieve multiple category settings
   * @returns any Get many base response
   * @throws ApiError
   */
  public getGameCategorySettings(dto: GetGameCategorySettingsDto): CancelablePromise<ListResponseDto<CategorySettingsItemDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/game-category-settings',
      query: dto,
    });
  }
  /**
   * Create a single category locale settings
   * @returns GameCategorySettingsEntity Get create one base response
   * @throws ApiError
   */
  public createOneGameCategorySettings({
    requestBody,
  }: {
    requestBody: CreateGameCategorySettingsDto,
  }): CancelablePromise<GameCategorySettingsEntity> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/game-category-settings',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Create a multiple category locale settings
   * @returns GameCategorySettingsEntity Get create many base response
   * @throws ApiError
   */
  public createManyGameCategorySettings({
    requestBody,
  }: {
    requestBody: CreateManyGameCategorySettingsEntityDto,
  }): CancelablePromise<Array<GameCategorySettingsEntity>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/game-category-settings/bulk',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Update a single category locale settings
   * @returns GameCategorySettingsEntity Response
   * @throws ApiError
   */
  public updateOneGameCategorySettings({
    categoryId,
    localeId,
    presetId,
    requestBody,
  }: {
    categoryId: number,
    localeId: number,
    presetId: number,
    requestBody: UpdateGameCategorySettingsDto,
  }): CancelablePromise<GameCategorySettingsEntity> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/game-category-settings/{categoryId}/{localeId}/{presetId}',
      path: {
        'categoryId': categoryId,
        'localeId': localeId,
        'presetId': presetId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete a single category locale settings
   * @returns any Delete one base response
   * @throws ApiError
   */
  public deleteOneGameCategorySettings({
    categoryId,
    localeId,
    presetId,
  }: {
    categoryId: number,
    localeId: number,
    presetId: number,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/game-category-settings/{categoryId}/{localeId}/{presetId}',
      path: {
        'categoryId': categoryId,
        'localeId': localeId,
        'presetId': presetId,
      },
    });
  }

  async updateCategorySettings(categoryId: number, dto: UpdateCategorySettingsItemDto): Promise<{success: boolean}> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/game-category-settings/update-category-settings/{categoryId}',
      path: {
        'categoryId': categoryId,
      },
      body: dto,
      mediaType: 'application/json',
    });
  }

  async removeCategorySettings(categoryId: number, dto: UpdateCategorySettingsItemDto): Promise<{success: boolean}> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/game-category-settings/remove-category-settings/{categoryId}',
      path: {
        'categoryId': categoryId,
      },
      body: dto,
      mediaType: 'application/json',
    });
  }
}
